import React from 'react';
import PropTypes from 'prop-types';
import { areObjectsSame } from "../../utils/helpers";
import { cloneElement } from 'react';

const withSaveButton = (WrappedComponent) => {
    const WithSaveButton = ({ onContentChanged, ...props }) => {

        const handleFormDataChange = newData => {
            //console.log("props.Data", props.data);
            //console.log("newData", newData);
            if(!onContentChanged)
                return;
            if(!areObjectsSame(newData, props.data))
                onContentChanged(true);
            else onContentChanged(false);
        };

        return <WrappedComponent onFormDataChange={handleFormDataChange} {...props} />;
    };

    WithSaveButton.propTypes = {
        data: PropTypes.object,
        onContentChanged: PropTypes.func
    };

    return WithSaveButton;
};

export default withSaveButton;
